import React, { useEffect, useState } from 'react'
import { postHGnombre, postHGquirofano } from '../../../services/PaginaRuta'
import GastosCirugia from './GastosCirugia'
import ModalCambiarEstadoDiligenciadoHG from './ModalCambiarEstadoDiligenciadoHG'
import ModalValidacionDespacho from './ModalValidacionDespacho'
import ModalValidacionEstadosHG from './ModalValidacionEstadosHG'
import ModalGastosCirugiaHG from './ModalGastosCirugiaHG'
import ModalConfirmarReimprimirHG from './ModalConfirmarReimprimirHG'

const TablaHojaGasto = ({item,passDataHojaGasto}) => {
  //const [nombreUser,setnombreUser]=useState([])
  //const [nombreQuirofano, setnombreQuirofano]=useState([])
  //const [estadoUser, setestadoUser]=useState('')
  //const [estadoGasto, setestadoGasto]=useState('')
  const [modalOnGastosCirugia, setmodalOnGastosCirugia]=useState(false)
  const [modalOnCambiarEstadoDiligenciado, setmodalOnCambiarEstadoDiligenciado]=useState(false)
  const [modalOnValidacionEstados, setmodalOnValidacionEstados]=useState(false)
  const [textEstados, settextEstados]=useState('')
  const [modalOnValidacionDespachos, setmodalOnValidacionDespachos]=useState(false)
  const [modalOnReimprimir, setmodalOnReimprimir]=useState(false)
  const [nombreBoton, setnombreBoton] = useState('')
  const handleOnclickCamibarEstadoDiligenciado=()=>{
    setmodalOnCambiarEstadoDiligenciado(true)
  }
  const handleOnclickGastosCirugia=()=>{

    if(item.PQEdoDes === 'P'){
      setmodalOnValidacionDespachos(true)
    }else if(item.ProEsta === '6' || item.ProEsta === '1' || item.ProEsta === '3' || item.ProEsta === '7' ){
      if(item.tieneCita === 'S'){
        console.log('tiene cita')
        setmodalOnValidacionEstados(true)
        settextEstados('El estado de la cita debe encontrarse en “Atendido” o “Preliquidado” para poder continuar, ya que no se ha generado el consecutivo de ingreso.!!')
      }else{
        setmodalOnValidacionEstados(true)
        settextEstados('El estado de la cirugía debe estar en Confirmado!!')
      }
      
    }else{
      setmodalOnGastosCirugia(true)
    }
    
  }
  useEffect(()=>{
    const condicionNombre = item.PqEdoGas ==='S'
    if(condicionNombre){
      setnombreBoton('Sin diligenciar')
    }else{
      setnombreBoton('Parcialmente diligenciado')
    }
    //console.log(item,'itemm')
    

  },[])

  const handleOnclickReimprimirPDF=()=>{
    setmodalOnReimprimir(true)
  }
  return (
    <>
    <tbody>
    <tr className=" divide-y divide-slate-700 ">
      <td></td>
        <td className="text-xs text-gray-900 font-medium px-2 py-2 whitespace-pre-wrap">
          {(item.PqEdoGas === 'D') || (item.PQEdoDes === 'C')?
          (item.PqEdoGas === 'D'? 
          <button
              onClick={handleOnclickReimprimirPDF}
              type="button"
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Reimprimir
            </button>
          :null)
          :
          <button
            onClick={handleOnclickGastosCirugia}
              type="button"
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              {nombreBoton}
            </button>
            }
          </td>
          <td className="text-xs text-gray-900 font-medium px-2 py-2 whitespace-pre-wrap">
          {item.PqEdoGas=='P'?
          <button
            onClick={handleOnclickCamibarEstadoDiligenciado}
              type="button"
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Diligenciado
            </button>
            :null}
          </td>
          <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {/* {item.CrgCod} */}
          {item.tieneCita? 'Si': 'No'}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {/* {item.CrgCod} */}
          {item.ProCirCod? item.ProCirCod:null}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
          {/* {item.CrgDes} */}
          {item.PaqCod? item.PaqCod:null}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.MPTDoc? item.MPTDoc:null}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
          {/* {item.CrgCnt} */}
          {item.MPCedu? item.MPCedu:null}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
          {/* {item.ViaCod} */}
          {item.MPNOMC? item.MPNOMC.trim():null}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {/* {item.MedCod} */}
          {item.ProCons? item.ProCons:null}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
          {item.ConsDet? item.ConsDet.trim(): null}
          {/* {nombreQuirofano.ConsDet? nombreQuirofano.ConsDet:null} */}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.PqEdoGas==='S'? 'Sin diligenciar':null}
          {item.PqEdoGas==='P'? 'Parcialmente diligenciado':null}
          {item.PqEdoGas==='D'? 'Diligenciado':null}
          {/* {estadoGasto? estadoGasto:null} */}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {/* {item.EspcDes} */}
          {/* {estadoUser?estadoUser:null} */}
          {item.ProEsta ==='6'? 'Pendiente': 
          (item.ProEsta ==='3'? 'Cancelado': 
          (item.ProEsta === '4'? 'Realizado' : 
          (item.ProEsta === '5'? 'Facturado' : 
          (item.ultimoEstado === 'reservado'? 'Reservado' : 
          (item.ultimoEstado === 'confirmado'? 'confirmado' : 
          (item.ultimoEstado === 'ingreso a sala'? 'ingreso a sala' : 
          (item.ultimoEstado ==='cirugia'? 'cirugia':
          (item.ultimoEstado ==='recuperacion'? 'recuperacion':
          (item.ultimoEstado === 'salida'? 'salida':
          (item.ProEsta === '1'? 'Reservado':
          (item.ProEsta === '7'? 'Reservado':
          (item.ProEsta === '2'? 'confirmado':
          (item.ProEsta === '8'? 'Pendiente':null)))))))))))))}
          
          {/* {item.ProEsta ==='4'? 'Recuperación':null} */}
        </td>
        
      </tr>
      </tbody>
      {/* {modalOnGastosCirugia? <GastosCirugia setmodalOnGastosCirugia={setmodalOnGastosCirugia} informacionUser={item} passDataHojaGasto={passDataHojaGasto}/>:null} */}
      {modalOnCambiarEstadoDiligenciado? <ModalCambiarEstadoDiligenciadoHG setmodalOnCambiarEstadoDiligenciado={setmodalOnCambiarEstadoDiligenciado} item={item} passDataHojaGasto={passDataHojaGasto}/>:null}
      {modalOnValidacionEstados? <ModalValidacionEstadosHG setmodalOnValidacionEstados={setmodalOnValidacionEstados} textEstados={textEstados}/>:null}
      {modalOnValidacionDespachos? <ModalValidacionDespacho setmodalOnValidacionDespachos={setmodalOnValidacionDespachos}/>:null}
      {modalOnGastosCirugia? <ModalGastosCirugiaHG setmodalOnGastosCirugia={setmodalOnGastosCirugia} informacionUser={item} passDataHojaGasto={passDataHojaGasto}/>:null}
      {modalOnReimprimir? <ModalConfirmarReimprimirHG setmodalOnReimprimir={setmodalOnReimprimir} item={item}/>:null}
      </>
  )
}

export default TablaHojaGasto